
const SEARCH_SET_WORD = (state, payload) =>{
    state.data.word = payload
}
const SEARCH_SET_LIST = (state, payload) =>{
    state.data.list = payload
}
const SEARCH_SET_TAGS = (state, payload) =>{
    state.data.tags = payload
}
const SEARCH_SET_SHOW = (state, payload) =>{
    state.data.show = payload
}
const SEARCH_INIT_SEARCH = (state, payload) =>{
    state.data.tags = [],
    state.data.list = null,
    state.data.word = '',
    state.data.show=false
}


export default {  
    SEARCH_SET_WORD,
    SEARCH_SET_LIST,
    SEARCH_SET_TAGS,
    SEARCH_SET_SHOW,
    SEARCH_INIT_SEARCH
};